// @flow
// like https://github.com/acdlite/recompose/blob/master/docs/API.md#withprops

import type { EasyCompComponent } from '../../type'

import * as React from 'react'
import { appendPropsSchema, appendPropsActions } from '../util/schemaUtil'

type CreateProps = (ownerProps: { [string]: any }) => {};

export default function (createProps: CreateProps) {
  return function (WrappedComponent: EasyCompComponent) {
    return class WithPropsComp extends React.PureComponent<*> {
      static actions = appendPropsActions(WrappedComponent);
      static schema = appendPropsSchema(WrappedComponent);

      wrappedComponent: ?React.Component<*>;

      render () {
        const props = {
          ...this.props,
          ...createProps(this.props)
        }
        return (
          <WrappedComponent
            ref={ref => {
              if (ref) {
                this.wrappedComponent = ref
              }
            }}
            {...props}
          />
        )
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/hoc/withProps.js